import { getReferencePosition } from "./getReferencePosition";

/**
 * This function is meant to be called when the `currentVideoTime` corresponds to a pause point. It
 * will find the corresponding play point and return that value, converted to seconds.
 */
export function getNearestPlayPoint({
  currentVideoTime,
  extended,
}: {
  currentVideoTime: number;
  extended: { pause: number; play: number }[];
}) {
  const referencePosition = getReferencePosition({
    currentVideoTime,
    extended,
  });

  const playPoint = referencePosition?.play ?? extended[0].play;

  return playPoint / 1000;
}
